import { TierItem } from "../pages/components/tierList";

export const videoGameList: TierItem[] = [
    // S Tier
    { name: "Assassin Creed 2", tier: "S" },
    { name: "Firewatch", tier: "S" },
    { name: "Half Life 2", tier: "S" },
    { name: "Half Life 2: Esp 1", tier: "S" },
    { name: "Half Life 2: Eps 2", tier: "S" },
    { name: "Half-Life Alyx", tier: "S" },
    { name: "Ori and the Blind Forest", tier: "S" },
    { name: "Ori and the Will of the Wisps", tier: "S" },
    { name: "Parkitech", tier: "S" },
    { name: "Portal", tier: "S" },
    { name: "Portal 2", tier: "S" },
    { name: "Beat Saber", tier: "S" },
    { name: "Mass Effect 2", tier: "S" },
    { name: "Stronghold 2", tier: "S" },
    { name: "Guild Wars 1", tier: "S" },
    { name: "Middle-Earth: Shadow of Mordor", tier: "S" },
    { name: "Aganist The Storm", tier: "S" },

    // A Tier
    { name: "League Of Legends", tier: "A" },
    { name: "Runescape", tier: "A" },
    { name: "Assassin Creed Brotherhood", tier: "A" },
    { name: "Assassin Creed Revelations", tier: "A" },
    { name: "Assassin Creed Black Flag", tier: "A" },
    { name: "Bioshock", tier: "A" },
    { name: "Dead Space", tier: "A" },
    { name: "Escape Simulator", tier: "A" },
    { name: "Islanders", tier: "A" },
    { name: "Left 4 Dead", tier: "A" },
    { name: "Roller Coaster Tycoon", tier: "A" },
    { name: "Roller Coaster Tycoon 2", tier: "A" },
    { name: "Tomb Raider (2013)", tier: "A" },
    { name: "The Witcher 3", tier: "A" },
    { name: "Day Of Defeat: Source", tier: "A" },
    { name: "Audiosurf", tier: "A" },
    { name: "City Skylines", tier: "A" },
    { name: "Civ 6", tier: "A" },
    { name: "Pistol Whip", tier: "A" },
    { name: "SubNautica", tier: "A" },
    { name: "Tom Clancy's Spilter Cell Blacklist", tier: "A" },
    { name: "Star wars Battlefront 2 (2005)", tier: "A" },
    { name: "Red Faction Guerrilla", tier: "A" },
    { name: "Far Cry 2", tier: "A" },
    { name: "Fallout 3", tier: "A" },
    { name: "Concert Jungle", tier: "A" },
    { name: "Call Of Duty, Black Ops", tier: "A" },
    { name: "Crash Team Racing", tier: "A" },
    { name: "Jack Box Games", tier: "A" },
    { name: "Overcooked", tier: "A" },
    { name: "Mini Metro", tier: "A" },
    { name: "Dorfromantik", tier: "A" },
    { name: "Divinity: Original Sin 2", tier: "A" },
    { name: "Baldur's gate 3", tier: "A" },
    { name: "Dicey Dungeons", tier: "A" },
    { name: "Two Point Museum", tier: "A" },

    // B Tier
    { name: "Bastion", tier: "B" },
    { name: "BioShock 2", tier: "B" },
    { name: "Borderlands", tier: "B" },
    { name: "Dead Space 2", tier: "B" },
    { name: "Deus Ex: Human Revolution", tier: "B" },
    { name: "Fallout 4", tier: "B" },
    { name: "Far Cry 3", tier: "B" },
    { name: "Left 4 Dead 2", tier: "B" },
    { name: "Limbo", tier: "B" },
    { name: "Massive Chalice", tier: "B" },
    { name: "Northguard", tier: "B" },
    { name: "Orcs Must Die!", tier: "B" },
    { name: "Outlast", tier: "B" },
    { name: "Planet Zoo", tier: "B" },
    { name: "Plants vs Zombies", tier: "B" },
    { name: "Sir You are being Hunted", tier: "B" },
    { name: "STALKER", tier: "B" },
    { name: "The Stanley Parable", tier: "B" },
    { name: "Styx: Master Of Shadows", tier: "B" },
    { name: "Super Meat Boy", tier: "B" },
    { name: "Trine", tier: "B" },
    { name: "Trine 2", tier: "B" },
    { name: "World Of Goo", tier: "B" },
    { name: "XCom 2", tier: "B" },
    { name: "Hoard", tier: "B" },
    { name: "Civ 2", tier: "B" },
    { name: "Civ 3", tier: "B" },
    { name: "Majesty: Gold", tier: "B" },
    { name: "The Long Dark", tier: "B" },
    { name: "Age of Empires 2", tier: "B" },
    { name: "Train Valley", tier: "B" },
    { name: "The Hunter: Call of the wild", tier: "B" },
    { name: "Mass Effect 1", tier: "B" },
    { name: "Valiant Hearts", tier: "B" },
    { name: "Tom Clancy's Splinter Cell Conviction", tier: "B" },
    { name: "Fallout New Vegas", tier: "B" },
    { name: "Banished", tier: "B" },
    { name: "Call Of Duty, Modern Warfare 2", tier: "B" },
    { name: "Zelda, Breath of the Wild", tier: "B" },
    { name: "Minecraft", tier: "B" },
    { name: "Stardew Valley", tier: "B" },
    { name: "Esacpe from Tarkov", tier: "B" },
    { name: "Hogwars Legacy", tier: "B" },

    // C Tier
    { name: "Alpha Protocol", tier: "C" },
    { name: "Amnesia: The Dark Descent", tier: "C" },
    { name: "Assassin's Creed", tier: "C" },
    { name: "Assassin's Creed 3", tier: "C" },
    { name: "Assassin's Creed Unity", tier: "C" },
    { name: "Assassin's Creed Syndicate", tier: "C" },
    { name: "Assassin's Creed Rogue", tier: "C" },
    { name: "Assassin's Creed Origins", tier: "C" },
    { name: "Assassin's Creed Odyssey", tier: "C" },
    { name: "BioShock Infinite", tier: "C" },
    { name: "Crayons Physics Delux", tier: "C" },
    { name: "Fear", tier: "C" },
    { name: "Foreign Legion: Buckets of Blood", tier: "C" },
    { name: "Mirror Edge", tier: "C" },
    { name: "Two Point Hospital", tier: "C" },
    { name: "VVVVVVV", tier: "C" },
    { name: "Watch Dogs", tier: "C" },
    { name: "Counter Strike: Source", tier: "C" },
    { name: "Counter Strike: GO", tier: "C" },
    { name: "Civ 5", tier: "C" },
    { name: "Invisible Inc", tier: "C" },
    { name: "Game Dev Tycoon", tier: "C" },
    { name: "Guild Wars 2", tier: "C" },
    { name: "Evoland", tier: "C" },
    { name: "Cogs", tier: "C" },
    { name: "Braid", tier: "C" },
    { name: "Mario Kart", tier: "C" },
    { name: "Cuphead", tier: "C" },
    { name: "Fortnite", tier: "C" },
    { name: "FrostPunk", tier: "C" },

    // F Tier
    { name: "Kane and Lynch: Dead Men", tier: "F" },
    { name: "Kane and Lynch 2: Dog Days", tier: "F" },
    { name: "Dishonored", tier: "F" },
    { name: "Amnesia: A Machine for Pigs", tier: "F" },
    { name: "Spore", tier: "F" },
    { name: "Prey", tier: "F" },
];
